import React, { useEffect } from "react";

const ContactPreferencesTable = ({
	register,
	error,
	field,
	id,
	watch,
	setValue,
	required = false,
}) => {
	const value = watch(id) || {};

	useEffect(() => {
		register(id, {
			required: required
				? "Please answer Yes or No for each contact method"
				: false,
			validate: (currentValue) => {
				if (!currentValue || typeof currentValue !== "object") {
					return "Please answer Yes or No for each contact method";
				}
				for (const option of field.options) {
					if (
						currentValue[option.value] !== true &&
						currentValue[option.value] !== false
					) {
						return "Please answer Yes or No for each contact method";
					}
				}
				return true;
			},
		});
	}, [register, id, field.options, required]);

	const handleChoice = (optionValue, choice) => {
		setValue(
			id,
			{ ...value, [optionValue]: choice },
			{ shouldValidate: true, shouldDirty: true },
		);
	};

	const legend = field.title || "Contact preferences";

	return (
		<fieldset
			className={`contact-preferences-table field${error ? " field--error" : ""}`}
		>
			<legend className={field.hide_label ? "sr-only" : "field-label"}>
				{legend}
				{required && <span className="required">*</span>}
			</legend>

			<table className="contact-preferences-table__table">
				<thead>
					<tr>
						<th scope="col" className="contact-preferences-table__method-col">
							<span className="sr-only">Contact method</span>
						</th>
						<th scope="col" className="contact-preferences-table__choice-col">
							Yes
						</th>
						<th scope="col" className="contact-preferences-table__choice-col">
							No
						</th>
					</tr>
				</thead>
				<tbody>
					{field.options.map((option) => {
						const rowValue = value[option.value];
						const yesId = `${id}-${option.value}-yes`;
						const noId = `${id}-${option.value}-no`;
						const rowLabel = option.opt_out
							? `${option.label} (Yes = opt out)`
							: option.label;

						return (
							<tr key={option.value}>
								<th
									scope="row"
									className="contact-preferences-table__method"
								>
									<span
										dangerouslySetInnerHTML={{ __html: option.label }}
									/>
									{required && <span className="required">*</span>}
								</th>
								<td className="contact-preferences-table__choice">
									<input
										type="radio"
										id={yesId}
										name={`${id}_${option.value}`}
										checked={rowValue === true}
										onChange={() => handleChoice(option.value, true)}
										aria-label={`Yes — ${rowLabel}`}
									/>
									<label htmlFor={yesId} className="sr-only">
										Yes
									</label>
								</td>
								<td className="contact-preferences-table__choice">
									<input
										type="radio"
										id={noId}
										name={`${id}_${option.value}`}
										checked={rowValue === false}
										onChange={() => handleChoice(option.value, false)}
										aria-label={`No — ${rowLabel}`}
									/>
									<label htmlFor={noId} className="sr-only">
										No
									</label>
								</td>
							</tr>
						);
					})}
				</tbody>
			</table>

			{error && <div className="field__error">{error.message}</div>}
		</fieldset>
	);
};

export default ContactPreferencesTable;
